export const GET_AGENCY_DATA = 'GET_AGENCY_DATA';
export const GET_AGENCY_DATA_SUCCESS = 'GET_AGENCY_DATA_SUCCESS';
export const GET_AGENCY_DATA_ERROR = 'GET_AGENCY_DATA_ERROR';

export const getAgencyData = () => ({ type: GET_AGENCY_DATA });
